import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog,
} from '@angular/material/legacy-dialog';
@Component({
  selector: 'decline-reason-modal',
  templateUrl: 'decline-reason-modal.component.html',
  styleUrls: ['decline-reason-modal.component.scss'],
})
export class DeclineReasonModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
